import React, { FC } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import Popup from 'src/components/content/popup/popup';
import ContentWrapper from 'src/components/content/content-wrapper';

import styles from './modal.module.scss';
import ContentSection from 'src/components/content/content-section';
import colors from 'src/styles/equalution/colors';
import { Button } from 'reactstrap';
import { ActionButton } from 'src/components/action-button';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const PersonalCoachRemoveConfirmationModal: FC<Props> = ({
  onClose,
  onConfirm,
  isLoading,
}) => {
  return (
    <Popup onClose={onClose}>
      <ContentWrapper className={styles.background}>
        <ContentSection className={styles.confirmContent} collapseAt="sm">
          <Button className={styles.close} onClick={onClose} />

          <Stack alignItems={'center'} mt={3}>
            <Typography
              fontSize={32}
              fontWeight={700}
              color={colors.OFF_BLACK}
              textAlign="center"
              paddingX={'32px'}
              gutterBottom>
              Remove Coaching Add-On?
            </Typography>

            <Typography
              mt={2}
              fontSize={16}
              fontWeight={400}
              color={colors.BLUEBERRY_HALF}
              textAlign="center"
              gutterBottom>
              This will be updated on your next billing cycle.
            </Typography>

            <Box mt={4} width="100%">
              <ActionButton isLoading={isLoading} onClick={onConfirm} size="md">
                Confirm to remove
              </ActionButton>
            </Box>
          </Stack>
        </ContentSection>
      </ContentWrapper>
    </Popup>
  );
};
